import { Observable } from 'rxjs';
import { CommercialCategoryTreeNode } from 'src/app/presentation/shared/interfaces/commercial-categories.interface';
import { UseCase } from '../base/use-case';
import { CommercialCategoryRepository } from '../repositories/commercial-categories.repository';

export class GetCategoryHierarchyUseCase
  implements UseCase<{ countryCode: string; categoryId: string }, CommercialCategoryTreeNode[]>
{
  constructor(private commercialCategoryRepository: CommercialCategoryRepository) {}

  execute(param: {
    countryCode: string;
    categoryId: string;
  }): Observable<CommercialCategoryTreeNode[]> {
    return this.commercialCategoryRepository.getCategoryHierarchy(
      param.countryCode,
      param.categoryId,
    );
  }
}
